module.exports = __webpack_public_path__ + "static/media/iphone_14_starlight_plus.8d857db3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_starlight_plus.jpeg
// module id = 2128
// module chunks = 0